import React from "react"

const NetworkApplicationsContext = React.createContext({})

const { Provider, Consumer } = NetworkApplicationsContext

export { Provider, Consumer, NetworkApplicationsContext }
